/** 실제 react-rnd 드래그 부모 — MainPage 의 flexFill div 에 부여되는 식별자. */
export const WINDOW_PLANE_ID = 'window-plane';

export interface WindowPlaneSize {
  width: number;
  height: number;
}

/**
 * 윈도우 bounds/min 계산의 측정 기준 — 실제 react-rnd 부모(#window-plane)의
 * clientWidth/Height 를 반환한다. #main-content(padding 24px 포함)로 측정하면 실부모보다
 * 가로·세로 48px 큰 기준계로 clamp 되어 좁은 뷰포트에서 창이 부모를 넘쳐 드래그가 잠긴다.
 * 요소 부재 시 #main-content → 0×0 순 폴백(스토리북/jsdom 안전 — 0×0 은
 * resolveInitialBounds 가 detached 로 처리).
 */
export function readWindowPlaneSize(): WindowPlaneSize {
  if (typeof document === 'undefined') return { width: 0, height: 0 };
  const planeEl = document.getElementById(WINDOW_PLANE_ID);
  if (planeEl) return { width: planeEl.clientWidth, height: planeEl.clientHeight };
  const mainEl = document.getElementById('main-content');
  if (mainEl) return { width: mainEl.clientWidth, height: mainEl.clientHeight };
  return { width: 0, height: 0 };
}
